import React from "react";
import { Badge, Row, Col } from "react-bootstrap";
import { CommonModal, CommonButton } from "../../Input";
import DetailField from "../../Customers/CustomerDetails/DetailField";

const SectionContainer = ({ title, children }) => (
  <div className="mb-4 ">
    <h6 className="fw-bold mb-2 fs-14 text-black">{title}</h6>
    <div className=" rounded-2 p-4 bg-body">
      <Row className="gy-3">{children}</Row>
    </div>
  </div>
);

const TopupDetailsModal = ({ show, onHide, transaction }) => {
  if (!transaction) return null;

  return (
    <CommonModal
      show={show}
      onHide={onHide}
      title={
        <div>
          <h4 className="fw-bold text-black mb-1">Topup details</h4>
          <p className="fs-13 text-muted mb-0 fw-normal">
            View the transaction summary
          </p>
        </div>
      }
      size="xl"
      className="modal-premium"
      modalProps={{
        centered: true,
      }}
      footerContent={
        <div className="px-4 pb-4 w-100">
          <CommonButton
            variant="primary"
            className="w-100 py-2 fs-15 fw-bold"
            onClick={onHide}
          >
            Done
          </CommonButton>
        </div>
      }
    >
      <div className="px-1">
        <SectionContainer title="Transaction summary">
          <Col xs={6}>
            <DetailField label="Created time" value={transaction.createdTime} />
          </Col>
          <Col xs={6}>
            <DetailField
              label="Unique ID"
              value={transaction.uniqueId || "NSU8X3"}
            />
          </Col>
          <Col xs={6}>
            <DetailField label="Transaction ID" value={transaction.id} />
          </Col>
          <Col xs={6}>
            <DetailField label="Topup method" value={transaction.type} />
          </Col>
          <Col xs={6}>
            <DetailField label="Top up amount" value={transaction.amount} />
          </Col>
          <Col xs={6}>
            <div className="mb-0">
              <label
                className="d-block text-muted mb-1"
                style={{ fontSize: "12px" }}
              >
                Status
              </label>
              <Badge
                bg={transaction.status === "Approved" ? "success" : "warning"}
                className={`rounded-2 py-1 px-2 fs-12 fw-medium ${
                  transaction.status === "Approved"
                    ? "bg-opacity-100"
                    : "text-white"
                }`}
                style={{
                  backgroundColor:
                    transaction.status === "Approved" ? "#006B44" : "#F3A01C",
                  minWidth: "80px",
                }}
              >
                {transaction.status}
              </Badge>
            </div>
          </Col>
        </SectionContainer>
      </div>
    </CommonModal>
  );
};

export default TopupDetailsModal;
